import { track } from '@zillow/universal-analytics';
export var GA_CATEGORY = 'HomeWorthPropertySearch';
export var PROPERTY_SEARCH_ACTION = 'AddressSubmit';
export var REVIEW_LIGHTBOX_ACTION = 'Review';
export var CONTACT_LIGHTBOX_ACTION = 'Contact';
export function concatWithPipe(labelPieces) {
  return labelPieces.filter(Boolean).join('|');
}
export var getIsSemTraffic = function getIsSemTraffic(query) {
  if (query !== undefined) {
    var semBoolean = query.sem === 'true';
    return semBoolean;
  }

  return false;
};
export var getTrafficLabel = function getTrafficLabel(query) {
  return getIsSemTraffic(query) ? 'SEM_PaidContactForm' : 'SEL_OrganicContactForm';
};

var getEvent = function getEvent(config) {
  return track(Object.assign({}, config, {
    category: GA_CATEGORY
  }));
};

export var trackHdpLinkClick = function trackHdpLinkClick(surfaceId, placementId) {
  return getEvent({
    action: REVIEW_LIGHTBOX_ACTION,
    label: concatWithPipe(['Click', surfaceId, placementId, 'view-home'])
  });
};
export var trackFSBOClick = function trackFSBOClick(surfaceId, placementId) {
  return getEvent({
    action: REVIEW_LIGHTBOX_ACTION,
    label: concatWithPipe(['Click', surfaceId, placementId, 'list-fsbo'])
  });
};
export var trackSellingTipsClick = function trackSellingTipsClick(surfaceId, placementId) {
  return getEvent({
    action: REVIEW_LIGHTBOX_ACTION,
    label: concatWithPipe(['Click', surfaceId, placementId, 'selling-tips'])
  });
};
export var trackContactAgentFormLinkClick = function trackContactAgentFormLinkClick(surfaceId, placementId) {
  return getEvent({
    action: REVIEW_LIGHTBOX_ACTION,
    label: concatWithPipe(['Click', surfaceId, placementId, 'contact-agent'])
  });
};
export var trackHmimhwPropertySearchDisplay = function trackHmimhwPropertySearchDisplay(placementId, surfaceId) {
  return getEvent({
    action: PROPERTY_SEARCH_ACTION,
    label: concatWithPipe(['Display', surfaceId, placementId])
  });
};
export var trackAddressSearch = function trackAddressSearch(surfaceId, placementId) {
  return getEvent({
    action: PROPERTY_SEARCH_ACTION,
    label: concatWithPipe(['Search', surfaceId, placementId])
  });
};
export var trackHmimhwPropertySearchError = function trackHmimhwPropertySearchError(placementId, surfaceId, error) {
  return getEvent({
    action: PROPERTY_SEARCH_ACTION,
    label: concatWithPipe(['Failure', surfaceId, placementId, error])
  });
};
export var trackHmimhwReviewLightboxDisplay = function trackHmimhwReviewLightboxDisplay(surfaceId, placementId) {
  return getEvent({
    action: REVIEW_LIGHTBOX_ACTION,
    label: concatWithPipe(['Display', surfaceId, placementId])
  });
};
export var trackHmimhwContactDisplay = function trackHmimhwContactDisplay(surfaceId, placementId) {
  return getEvent({
    action: CONTACT_LIGHTBOX_ACTION,
    label: concatWithPipe(['Display', surfaceId, placementId])
  });
};
//# sourceMappingURL=gaUtils.js.map